
import coinbasePay from "~/services/coinbase-pay";
import { toExplorerAddress } from "~/utils/helpers";

export default {
  name: "ModalWallet",

  data() {
    return {
      copyText: "Copy to clipboard",
    };
  },

  computed: {
    account() {
      return this.$store.getters.walletAddress;
    },

    etherscanUrl() {
      return toExplorerAddress(this.account);
    },
  },

  methods: {
    open() {
      this.$refs.modal.open();
    },

    onRamp() {
      coinbasePay(this.account, "buy");
    },

    offRamp() {
      coinbasePay(this.account, "send");
    },

    copyToClipboard() {
      navigator.clipboard.writeText(this.account);
      this.copyText = "Copied!";
    },

    resetCopyText() {
      setTimeout(() => {
        this.copyText = "Copy to clipboard";
      }, 300);
    },
  },
};
